import React from 'react';
import { MapPinIcon, LinkedinIcon, InstagramIcon, MailIcon, ArrowUpRightIcon } from 'lucide-react';
import { contact, profile, cv } from '../data/cv';
import { ui } from '../data/ui';
import { useLanguage } from '../contexts/LanguageContext';
export function SiteFooter() {
  const {
    language
  } = useLanguage();
  const strings = ui[language];
  const content = cv[language];
  return <footer id="contact" className="border-t border-blush-300/70 bg-blush-200/60" data-id="element-24" data-mp="3dhe1dnd7jw8m">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8" data-id="element-25" data-mp="38hrqvlorku3i">
        <div className="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end lg:gap-14" data-id="element-26" data-mp="38ggjzd00v686">
          <div data-id="element-27" data-mp="33jgh1aygyjla">
            <h2 className="text-xl font-semibold uppercase tracking-[0.3em] text-ink" data-id="element-28" data-mp="33ix6ifb5exha">
              {strings.sections.contact}
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-ink/75" data-id="element-29" data-mp="11rtw9r567kx9">
              {strings.form.intro}
            </p>
            <p className="mt-6 flex items-center gap-3 text-sm text-ink/80" data-id="element-30" data-mp="wtimfgevlaf1">
              <MapPinIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-31" data-mp="15qlt47dtlwoa" />
              <span data-id="element-32" data-mp="1apyc2h1kmjll">
                <span className="sr-only" data-id="element-33" data-mp="1aq874j1h3gy5">{strings.form.basedIn}: </span>
                {contact.address}
              </span>
            </p>
            <p className="mt-3 flex items-center gap-3 text-sm text-ink/80" data-id="element-34" data-mp="vuiew35p27kz">
              <MailIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-35" data-mp="10sjycp7188wz" />
              <a href={`mailto:${contact.email}`} className="break-all underline decoration-ink/25 underline-offset-4 transition-colors hover:text-ink hover:decoration-ink" data-id="element-36" data-mp="1ogtilmolkom0">
                {contact.email}
              </a>
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row lg:flex-col" data-id="element-37" data-mp="1jpuxm9snz2cf">
            <a href={`mailto:${contact.email}`} className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-blush-50 transition-colors hover:bg-ink/80" data-id="element-38" data-mp="27g7g2eljchh9">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="2m0tn7pr5wpfr" />
              {strings.form.linkedinCta}
            </a>
            <a href={contact.linkedin.url} target="_blank" rel="noreferrer noopener" className="inline-flex items-center justify-center gap-2 rounded-full border border-ink/25 px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors hover:bg-white" data-id="element-40" data-mp="2d27vb3zsvy2b">
              <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="1ycjwc9f3dbhr" />
              LinkedIn
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="1tfa82x3fv5vi" />
            </a>
            <a href={contact.instagram.url} target="_blank" rel="noreferrer noopener" className="inline-flex items-center justify-center gap-2 rounded-full border border-ink/25 px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors hover:bg-white" data-id="element-43" data-mp="1pdgd95fxcw39">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="3r3x9ho0ewrqx" />
              {contact.instagram.label}
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="3w2qltd3yqcpi" />
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-ink/10 pt-6 sm:flex-row sm:items-baseline sm:justify-between" data-id="element-46" data-mp="8vy1s1nnl2vq">
          <span className="font-script text-2xl text-ink" data-id="element-47" data-mp="38ce7nki4jjqh">
            {profile.firstName} {profile.lastName}
          </span>
          <span className="text-xs uppercase tracking-[0.2em] text-ink/50" data-id="element-48" data-mp="3dao2tv3umkc3">
            © {new Date().getFullYear()} — {content.tagline}
          </span>
        </div>
      </div>
    </footer>;
}